import { useNavigate } from "react-router-dom";
import { getUserSubscription } from "../../apihelper/profile";

export const useGoToSubscription = () => {
    const navigate = useNavigate();

    return async () => {
        const userData = JSON.parse(localStorage.getItem("cw_portfolio_user"));
        if (userData?.user_id) {
            try {
                const status = await getUserSubscription(userData);
                if (status.is_subscribed) {
                    navigate("/my-subscriptions");
                } else {
                    navigate("/subscriptions");
                }
            } catch (error) {
                console.error("Error fetching subscription:", error);
                navigate("/subscriptions");
            }
        } else {
            navigate("/subscriptions");
        }
    };
};

